module.exports = __webpack_public_path__ + "img/404.33772a52.png";